<template>
  <section class="py-16 bg-neutrals-surface">
    <div class="container mx-auto px-6 max-w-7xl">
      <div
        class="bg-neutrals-background rounded-3xl shadow-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center justify-between gap-12"
      >
        <!-- Formulário -->
        <div v-if="!formSubmitted" class="w-full lg:w-1/2" data-aos="fade-right">
          <h2
            class="text-3xl md:text-4xl font-extrabold text-neutrals-text mb-4 leading-tight"
          >
            Fale com a gente e encontre o
            <span class="text-primary">seu imóvel ideal</span>.
          </h2>
          <p class="text-lg text-neutrals-muted mb-8">
            Preencha o formulário abaixo para tirar dúvidas, agendar uma visita
            ou receber mais informações.
          </p>

          <form @submit.prevent="handleSubmit" class="space-y-6">
            <div>
              <label
                for="name"
                class="block text-sm font-medium text-neutrals-text"
                >Nome Completo</label
              >
              <input
                type="text"
                id="name"
                v-model="form.name"
                required
                class="mt-1 block w-full px-4 py-3 border border-neutrals-muted rounded-xl shadow-sm focus:ring-primary focus:border-primary transition-all duration-300"
              />
            </div>

            <div>
              <label
                for="email"
                class="block text-sm font-medium text-neutrals-text"
                >Email</label
              >
              <input
                type="email"
                id="email"
                v-model="form.email"
                required
                class="mt-1 block w-full px-4 py-3 border border-neutrals-muted rounded-xl shadow-sm focus:ring-primary focus:border-primary transition-all duration-300"
              />
            </div>

            <div>
              <label
                for="phone"
                class="block text-sm font-medium text-neutrals-text"
                >Telefone</label
              >
              <input
                type="tel"
                id="phone"
                v-model="form.phone"
                required
                v-maska="'(##) #####-####'"
                class="mt-1 block w-full px-4 py-3 border border-neutrals-muted rounded-xl shadow-sm focus:ring-primary focus:border-primary transition-all duration-300"
              />
            </div>

            <div>
              <label
                for="interest"
                class="block text-sm font-medium text-neutrals-text"
                >Eu tenho interesse em...</label
              >
              <select
                id="interest"
                v-model="form.interest"
                class="mt-1 block w-full px-4 py-3 border border-neutrals-muted rounded-xl shadow-sm focus:ring-primary focus:border-primary transition-all duration-300"
              >
                <option value="">Selecione uma opção</option>
                <option value="buy">Comprar um imóvel</option>
                <option value="rent">Alugar um imóvel</option>
                <option value="sell">Cadastrar meu imóvel para venda</option>
                <option value="rent_out">
                  Cadastrar meu imóvel para aluguel
                </option>
                <option value="others">Outros</option>
              </select>
            </div>

            <div>
              <label
                for="message"
                class="block text-sm font-medium text-neutrals-text"
                >Sua mensagem</label
              >
              <textarea
                id="message"
                v-model="form.message"
                rows="4"
                required
                class="mt-1 block w-full px-4 py-3 border border-neutrals-muted rounded-xl shadow-sm focus:ring-primary focus:border-primary transition-all duration-300"
              ></textarea>
            </div>

            <button
              type="submit"
              class="w-full py-4 px-6 bg-primary text-white font-bold rounded-full shadow-lg hover:bg-primary transition-all duration-300 flex items-center justify-center gap-2"
              :disabled="loading"
            >
              <svg
                v-if="loading"
                class="animate-spin h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  class="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="4"
                ></circle>
                <path
                  class="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              {{ loading ? "Enviando..." : "Enviar Mensagem" }}
            </button>
          </form>
        </div>

        <!-- Mensagem de sucesso -->
        <div v-else class="w-full lg:w-1/2 text-center py-20" data-aos="zoom-in">
          <svg
            class="mx-auto w-24 h-24 text-states-success mb-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
          <h3 class="text-3xl md:text-4xl font-extrabold text-neutrals-text mb-4">
            Mensagem enviada com sucesso!
          </h3>
          <p class="text-lg text-neutrals-muted mb-8">
            Agradecemos o seu contato. Nossa equipe retornará em breve.
          </p>
          <button
            @click="resetForm"
            class="px-8 py-3 bg-primary text-white font-bold rounded-full shadow-lg hover:bg-primary transition-all duration-300"
          >
            Enviar outra mensagem
          </button>
        </div>

        <!-- Imagem -->
        <div
          class="hidden lg:block w-full lg:w-1/2 rounded-2xl overflow-hidden"
          data-aos="fade-left"
        >
          <img
            src="banner_contato.jpg"
            alt="Imagem de Imóveis"
            class="w-full h-full object-cover"
          />
        </div>
      </div>
    </div>
  </section>
</template>


<script setup>
import { ref } from 'vue';
import { vMaska } from "maska/vue";
import api from '@/services/api';
import {
    useMessage,
} from "naive-ui";


const message = useMessage();
const form = ref({
    name: '',
    email: '',
    phone: '',
    interest: '',
    message: '',
});

const loading = ref(false);
const formSubmitted = ref(false);

async function handleSubmit() {
    if (loading.value) return;

    if (!form.value.name || !form.value.email || !form.value.phone || !form.value.message) {
        message.warning(
            "Por favor, preencha todos os campos obrigatórios.",
            { duration: 6000 }
        );
        return;
    }

    loading.value = true;

    formSubmitted.value = true;

    try {
        await api.post('/send-contact-email', form.value);
        //message.success(response.data.message, { duration: 6000 });

    } catch (error) {
        console.error("Erro ao enviar o formulário:", error.response || error);

        message.error(
            error.response.data.error ||
            "Ocorreu um erro ao enviar o formulário. Tente novamente mais tarde.",
            { duration: 6000 }
        );
    } finally {
        loading.value = false;
    }
}

const resetForm = () => {
    formSubmitted.value = false;
    form.value = {
        name: '',
        email: '',
        phone: '',
        interest: '',
        message: '',
    };
};
</script>